<template>
  <a-row :gutter="16">
    <a-col :xxl="6" :xl="8" :lg="8" :md="12">
      <a-input-group compact>
        <a-select v-model:value="queryForm.datetype" :options="datetypes" :filter-option="$filters.filterOption"
          show-search style="width:30%;" />
        <a-range-picker v-model:value="queryForm.daterange" :ranges="ranges" :locale="locale" value-format="YYYY-MM-DD"
          style="width:70%;" />
      </a-input-group>
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-select v-model:value="queryForm.orgid" :options="qorgs" :filter-option="$filters.filterOption" show-search
        style="width:100%;" />
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-input v-model:value="queryForm.order_number" placeholder="订单号" style="width:100%;" />
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-input v-model:value="queryForm.tracking_number" placeholder="物流单号" style="width:100%;" />
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-input v-model:value="queryForm.shop_name" placeholder="店铺名称" style="width:100%;" />
    </a-col>
    <a-col :xxl="3" :xl="4" :lg="8" :md="12">
      <a-button type="primary" @click="refresh">查询</a-button>
    </a-col>
  </a-row>
  <div class="d-flex justify-space-between align-center mb-2 mt-2">
    <a-space>
      <a-button type="link" @click="refresh">刷新数据</a-button>
    </a-space>
    <a-space>
      <a-button type="primary" @click="getTMS">查看TMS数据</a-button>
      <a-dropdown>
        <template #overlay>
          <a-menu>
            <a-menu-item @click="exportselected" :disabled="selectedRowKeys.length === 0">导出勾选</a-menu-item>
            <a-menu-item @click="exportall">导出所有页</a-menu-item>
            <a-menu-item @click="exporttask" class="text-error">查看导出任务</a-menu-item>
          </a-menu>
        </template>
        <a-button type="primary">
          导出数据
          <DownOutlined />
        </a-button>
      </a-dropdown>
    </a-space>
  </div>
  <div class="static">
    <a-row>
      <a-col :span="6">
        <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
          <span class="text-gray">总订单数</span>
          <LoadingOutlined style="text-align: left;" />
        </div>
        <a-statistic v-else title="总订单数" :value="total_count" style="margin-right: 50px" />
      </a-col>
      <a-col :span="6">
        <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
          <span class="text-gray">总金额(¥)</span>
          <LoadingOutlined style="text-align: left;" />
        </div>
        <a-statistic v-else title="总金额(¥)" :precision="2" :value="total_amount" />
      </a-col>
      <a-col :span="6">
        <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
          <span class="text-gray">退单数</span>
          <LoadingOutlined style="text-align: left;" />
        </div>
        <a-statistic v-else title="退单数" :value="return_count" />
      </a-col>
      <a-col :span="6">
        <div v-if="loading" style="height:64px;" class="d-flex flex-column justify-space-between">
          <span class="text-gray">退单金额</span>
          <LoadingOutlined style="text-align: left;" />
        </div>
        <a-statistic v-else title="退单金额" :precision="2" :value="return_amount" />
      </a-col>
    </a-row>
  </div>
  <a-table :columns="columns" bordered :data-source="data" :loading="dataLoading" :scroll="{ x: width, y: 600 }"
    :pagination="{
      current: page,
      pageSize: limit,
      total: count,
      showQuickJumper: true,
      showSizeChanger: true,
    }" @change="(pagination) => { page = pagination.current; limit = pagination.pageSize; }" row-key="_id"
    :row-selection="{ selectedRowKeys, onChange: (keys) => selectedRowKeys = keys }">
    <template #bodyCell="{ record, column }">
      <template v-if="column.dataIndex === 'platform'">
        {{ getplatform(record.platform) }}
      </template>
      <template v-if="column.dataIndex === 'org'">
        {{ getorgname(record.orgid) }}
      </template>
      <template v-if="column.dataIndex === 'country'">
        {{ record.country || record.country_code || record.country_name }}
      </template>
      <template v-if="column.dataIndex === 'amount'">
        {{ record.amount }} {{ record.currency }}
      </template>
      <template v-if="column.dataIndex === 'amount2'">
        <p>{{ record.amount2 }}</p>
        <p v-if="record.deleted" class="text-error">已退单</p>
      </template>
    </template>
  </a-table>
  <a-modal v-model:visible="tmsModal" title="查看TMS出库数量" :maskClosable="false" width="800px" :footer="null">
    <a-row :gutter="16" style="margin-bottom: 5px;">
      <a-col :span="8">
        <a-select v-model:value="tmsForm.orgid" :options="qorgs" :filter-option="$filters.filterOption" show-search
          style="width:100%;" />
      </a-col>
      <a-col :span="10">
        <a-range-picker v-model:value="tmsForm.daterange" :ranges="ranges" :locale="locale" value-format="YYYY-MM-DD"
          style="width:100%;" :placeholder="['出库开始时间', '出库结束时间']" />
      </a-col>
      <a-col :span="6">
        <a-space>
          <a-button type="primary" @click="get_tms_counts" :loading="tmsDataLoading">查询</a-button>
          <a-button type="primary" @click="download_tms_counts" :loading="tmsDownLoading">导出</a-button>
        </a-space>
      </a-col>
    </a-row>
    <a-table :columns="tms_columns" bordered :data-source="tmsData" :loading="tmsDataLoading"
      :scroll="{ x: tms_width, y: 600 }" row-key="orgid" :pagination="false" size="small">
      <template #summary>
        <a-table-summary fixed="top">
          <a-table-summary-row>
            <a-table-summary-cell :index="0" :col-span="1">
              <p class="text-h6 text-error text-center">合计({{ tmsData.length }})</p>
            </a-table-summary-cell>
            <a-table-summary-cell :index="1">
              <p class="text-error text-h6 text-center">
                {{ tms_counts }}
              </p>
            </a-table-summary-cell>
          </a-table-summary-row>
        </a-table-summary>
      </template>
    </a-table>
    <!-- <template #footer>
      <div class="text-center">
        <a-button type="primary" @click="close_tms_modal">关闭</a-button>
      </div>
    </template> -->
  </a-modal>
  <Download ref="downloadRef" />
</template>
<script setup>
import dayjs from 'dayjs';
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import { DownOutlined, LoadingOutlined } from "@ant-design/icons-vue";
import { message } from "ant-design-vue";
import Download from "@/components/download.vue";
import { ref, watch, computed, onMounted, getCurrentInstance, } from "vue";
import _ from "underscore";
const { proxy } = getCurrentInstance();

const columns = [
  { title: '电商平台', dataIndex: 'platform', width: 100 },
  { title: '商户', dataIndex: 'org', width: 120 },
  { title: '店铺名称', dataIndex: 'shop_name', width: 180, },
  { title: '订单号', dataIndex: 'order_number', width: 180 },
  { title: '物流单号', dataIndex: 'tracking_number', width: 180 },
  { title: '国家/地区', dataIndex: 'country', width: 120, },
  { title: '总金额(原始货币)', dataIndex: 'amount', width: 150, },
  { title: '总金额(￥)', dataIndex: 'amount2', width: 150, },
  { title: '付款时间', dataIndex: 'pay_time', width: 120 },
  { title: '发货时间', dataIndex: 'delivering_time', width: 120 },
  { title: '创建时间', dataIndex: 'createtime', width: 120, },
];
const tms_columns = [
  { title: '商户', dataIndex: 'org_name', width: 180 },
  { title: '数量', dataIndex: 'count', width: 80, align: 'center' },
];
const datetypes = ref([
  { value: 2, label: "发货时间" },
  { value: 1, label: "付款时间" },
]);
const ranges = ref({
  '近一周': [dayjs().subtract(7, 'day'), dayjs()],
  '近一月': [dayjs().subtract(1, 'month'), dayjs()],
  '近三月': [dayjs().subtract(3, 'month'), dayjs()],
  '近六月': [dayjs().subtract(6, 'month'), dayjs()],
});
const downloadRef = ref();

const queryForm = ref({
  datetype: 2,
  daterange: ["", ""],
  orgid: "ALL",
  order_number: "",
  tracking_number: "",
  shop_name: "",
});
const dataLoading = ref(false);
const loading = ref(false);
const page = ref(1);
const limit = ref(20);
const length = ref(0);
const count = ref(0);
const data = ref([]);
const total_count = ref(0);
const total_amount = ref(0);
const return_count = ref(0);
const return_amount = ref(0);
const countrys = ref([]);
const selectedRowKeys = ref([]);
const orgs = ref([]);

//Tms数据
const tmsModal = ref(false);
const tmsForm = ref({
  orgid: "ALL",
  daterange: [],
});
const tmsData = ref([]);
const tmsDataLoading = ref(false);
const tmsDownLoading = ref(false);

const width = computed(() => proxy.$utils.twidth(columns));
const tms_width = computed(() => proxy.$utils.twidth(tms_columns));
const sorgs = computed(() => orgs.value.map(n => ({ value: n._id, label: n.name })));
const qorgs = computed(() => {
  return [
    { value: 'ALL', label: '全部商户' },
    ...sorgs.value,
  ]
});
const tms_counts = computed(() => _.reduce(tmsData.value, (a, b) => a + b.count, 0));

watch(() => page.value, () => {
  getData();
});
watch(() => limit.value, () => {
  if (page.value !== 1) page.value = 1;
  else getData();
});

onMounted(() => {
  refresh();
});
const refresh = () => {
  getData();
  getStatistics();
}
const getData = () => {
  selectedRowKeys.value = [];
  dataLoading.value = true;
  proxy.$api.doAPI("/order/list", { page: page.value, limit: limit.value, ...queryForm.value }).then((res) => {
    dataLoading.value = false;
    if (res.code === 0) {
      data.value = res.data.list;
      length.value = res.data.length;
      count.value = res.data.count;
      if (length.value > 0 && page.value > length.value) page.value = 1;
      countrys.value = res.data.countrys;
      orgs.value = res.data.orgs;
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    dataLoading.value = false;
    console.error(err);
  });
};
const getStatistics = () => {
  loading.value = true;
  proxy.$api.doAPI("/order/statistics", { page: page.value, limit: limit.value, ...queryForm.value }).then((res) => {
    loading.value = false;
    if (res.code === 0) {
      total_count.value = res.data.total_count;
      total_amount.value = res.data.total_amount;
      return_count.value = res.data.return_count;
      return_amount.value = res.data.return_amount;
    } else {
      message.error(res.msg);
      loading.value = false;
    }
  }).catch((err) => {
    console.error(err);
  });
};
const getTMS = () => {
  tmsModal.value = true;
};
const get_tms_counts = () => {
  tmsDataLoading.value = true;
  proxy.$api.doAPI("/order/get_tms_counts", { ...tmsForm.value }).then((res) => {
    tmsDataLoading.value = false;
    if (res.code === 0) {
      tmsData.value = res.data.list;
      console.log(res.data.list);
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    tmsDataLoading.value = false;
    console.error(err);
  });
};
const download_tms_counts = () => {
  tmsDownLoading.value = true;
  proxy.$api.doAPI("/order/download_tms_counts", { ...tmsForm.value }).then((res) => {
    tmsDownLoading.value = false;
    if (res.code === 0) {
      proxy.$utils.download(res.data.url, res.data.name);
    } else {
      message.error(res.msg);
    }
  }).catch((err) => {
    tmsDownLoading.value = false;
    console.error(err);
  });
}
const close_tms_modal = () => {
  tmsModal.value = false;
};
const exportdata = (ids) => {
  return new Promise(resolve => {
    dataLoading.value = true;
    proxy.$api.doAPI("/order/list", { ...queryForm.value, ids, action: "download" }).then((res) => {
      dataLoading.value = false;
      resolve(true);
    }).catch((err) => {
      dataLoading.value = false;
      resolve(false);
      console.error(err);
    });
  })
}
const exportselected = () => {
  exportdata(selectedRowKeys.value).then((ok) => { if (ok) exporttask() });
}
const exportall = () => {
  exportdata([]).then((ok) => { if (ok) exporttask() });
}
const exporttask = () => {
  downloadRef.value.showDownload({ title: "导出订单", type: "order" });
}
const getplatform = (platform) => {
  return _.findWhere(proxy.$constant.platforms, { value: platform })?.label || platform;
}
const getorgname = (orgid) => {
  return _.findWhere(orgs.value, { _id: orgid })?.name;
}
</script>
<style lang="less" scoped>
:deep(.ant-layout-header) {
  display: flex;
  padding: 0 20px;
}

:deep(.ant-table-thead > tr > th) {
  padding: 8px 8px !important;
}

p {
  margin: 0;
  padding: 0;
}

.static {
  padding: 20px;
  background-color: #f2f2f2;
  margin-bottom: 10px;
}
</style>